import { proxy } from 'valtio';

export const currentBoardElementsState: {
  limitReached: boolean;
} = proxy({
  limitReached: false,
});

export const setElementsLimitReached = (limitReached: boolean) => {
  currentBoardElementsState.limitReached = limitReached;
};
